import Axios from "axios";
import {appConfig} from "./app-config";

let errorHandler = null;
let unauthorizedHandler = null;

const axiosInstance = Axios.create({
    baseURL: appConfig.apiUrl,
    headers: {Accept: "application/json"},
});

export const setHeaderToken = (token) => {
    if (token){
        axiosInstance.defaults.headers = {...axiosInstance.defaults.headers, Authorization:token};
    }
    else {
        delete axiosInstance.defaults.headers['Authorization'];
    }
};

export function getAdminUploadURL() {
    return new URL("../upload", axiosInstance.defaults.baseURL || window.location.origin).toString();
}

export const getAuthToken = (user) => user?.jwt || user?.token;

export const normalizeApiError = (error) => {
    const data = error?.response?.data;
    const backendError = data?.error;
    const details = backendError?.details || {};
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const message =
        data?.error?.message ||
        data?.error ||
        data?.message ||
        error?.message ||
        "api-error";

    return {
        status,
        data,
        url,
        message,
        code: details?.code || backendError?.code || error?.code,
        details,
        retryable: Boolean(details?.retryable),
        runId: details?.runId || null,
        stepId: details?.stepId || null,
        isNetworkError: !error?.response && (error?.code === "ERR_NETWORK" || error?.message === "Network Error"),
        original: error,
    };
};

export const setApiErrorHandler = (handler) => {
    errorHandler = handler;
};

export const setApiUnauthorizedHandler = (handler) => {
    unauthorizedHandler = handler;
};

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const normalizedError = normalizeApiError(error);
        error.normalizedError = normalizedError;
        error.message = normalizedError.message;

        if (normalizedError.status === 401 && unauthorizedHandler) {
            unauthorizedHandler(normalizedError);
        }
        else if (errorHandler && !error?.config?.suppressGlobalErrorHandler) {
            errorHandler(normalizedError);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;

